export default "__VITE_ASSET__CW6110ig__"